// extracted by mini-css-extract-plugin
export default {"wrapper":"woHoHXP","container":"WGs2gTp","title":"QIBXA5c","button":"Wm-R7hQ"};